import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	operationVerbalForm: {
		id: 'eoc.routing-rules.common-messages.operation-verbal-form.no-translate',
		defaultMessage: `{field} {not, select,
        true {does not}
        other {}
      } {operation} <strong>{expectedValue}</strong>`,
		description:
			'Full message of operation. Example: message contains important / message does not contains important',
	},
	operationVerbalFreeForm: {
		id: 'eoc.routing-rules.common-messages.operation-verbal-free-form.no-translate',
		defaultMessage: `value of {field} in extra properties {not, select,
        true {does not}
        other {}
      } {operation} <strong>{expectedValue}</strong>`,
		description:
			'Full message of freeform operation. Example: value of message in extra properties contains important / value of message in extra properties does not contains important',
	},
	or: {
		id: 'eoc.routing-rules.common-messages.or.no-translate',
		defaultMessage: '<strong>OR </strong>',
		description: '"Or" condition',
	},
	and: {
		id: 'eoc.routing-rules.common-messages.and.no-translate',
		defaultMessage: '<strong>AND </strong>',
		description: '"And" condition',
	},
	matches: {
		id: 'eoc.routing-rules.common-messages.matches.no-translate',
		defaultMessage: 'matches',
		description: '"matches" operation. example: message matches "critical"',
	},
	matches_singular: {
		id: 'eoc.routing-rules.common-messages.matches_singular.no-translate',
		defaultMessage: 'match',
		description:
			'singular version of "matches" operation. example: message does not match "critical"',
	},
	contains: {
		id: 'eoc.routing-rules.common-messages.contains.no-translate',
		defaultMessage: 'contains',
		description: '"contains" operation. example: message contains "critical"',
	},
	contains_singular: {
		id: 'eoc.routing-rules.common-messages.contains_singular.no-translate',
		defaultMessage: 'contain',
		description:
			'singular version of "contains" operation. example: message does not contain "critical"',
	},
	'starts-with': {
		id: 'eoc.routing-rules.common-messages.starts-with.no-translate',
		defaultMessage: 'starts with',
		description: '"starts-with" operation. example: message starts with "critical"',
	},
	'starts-with_singular': {
		id: 'eoc.routing-rules.common-messages.starts-with_singular.no-translate',
		defaultMessage: 'start with',
		description:
			'singular version of "starts-with" operation. example: message does not start with "critical"',
	},
	'ends-with': {
		id: 'eoc.routing-rules.common-messages.ends-with.no-translate',
		defaultMessage: 'ends with',
		description: '"ends-with" operation. example: message ends with "critical"',
	},
	'ends-with_singular': {
		id: 'eoc.routing-rules.common-messages.ends-with_singular.no-translate',
		defaultMessage: 'end with',
		description:
			'singular version of "ends-with" operation. example: message does not end with "critical"',
	},
	equals: {
		id: 'eoc.routing-rules.common-messages.equals.no-translate',
		defaultMessage: 'equals',
		description: '"equals" operation. example: message equals "critical"',
	},
	equals_singular: {
		id: 'eoc.routing-rules.common-messages.equals_singular.no-translate',
		defaultMessage: 'equal',
		description:
			'singular version of "equals" operation. example: message does not equal "critical"',
	},
	'contains-key': {
		id: 'eoc.routing-rules.common-messages.contains-key.no-translate',
		defaultMessage: 'contains key',
		description: '"contains-key" operation. example: message contains key "critical"',
	},
	'contains-key_singular': {
		id: 'eoc.routing-rules.common-messages.contains-key_singular.no-translate',
		defaultMessage: 'contain key',
		description:
			'singular version of "contains-key" operation. example: message does not contain key "critical"',
	},
	'contains-value': {
		id: 'eoc.routing-rules.common-messages.contains-value.no-translate',
		defaultMessage: 'contains value',
		description: '"contains-value" operation. example: message contains value "critical"',
	},
	'contains-value_singular': {
		id: 'eoc.routing-rules.common-messages.contains-value_singular.no-translate',
		defaultMessage: 'contain value',
		description:
			'singular version of "contains-value" operation. example: message does not contain value "critical"',
	},
	'greater-than': {
		id: 'eoc.routing-rules.common-messages.greater-than.no-translate',
		defaultMessage: 'greater than',
		description: '"greater-than" operation. example: message greater than "4"',
	},
	'greater-than_singular': {
		id: 'eoc.routing-rules.common-messages.greater-than_singular.no-translate',
		defaultMessage: 'greater than',
		description: '"greater-than" operation. example: message greater than "4"',
	},
	'less-than': {
		id: 'eoc.routing-rules.common-messages.less-than.no-translate',
		defaultMessage: 'less than',
		description: '"less-than" operation. example: message less than "5"',
	},
	'less-than_singular': {
		id: 'eoc.routing-rules.common-messages.less-than_singular.no-translate',
		defaultMessage: 'less than',
		description: '"less-than" operation. example: message less than "5"',
	},
	'is-empty': {
		id: 'eoc.routing-rules.common-messages.is-empty.no-translate',
		defaultMessage: 'is empty',
		description: '"is empty" operation. example: message is empty',
	},
	'is-empty_singular': {
		id: 'eoc.routing-rules.common-messages.is-empty_singular.no-translate',
		defaultMessage: 'is empty',
		description: '"is empty" operation. example: message is empty',
	},
	'equals-ignore-whitespace': {
		id: 'eoc.routing-rules.common-messages.equals-ignore-whitespace.no-translate',
		defaultMessage: 'equals ignore whitespace',
		description:
			'"equals-ignore-whitespace" operation. example: message equals ignore whitespace "critical"',
	},
	'equals-ignore-whitespace_singular': {
		id: 'eoc.routing-rules.common-messages.equals-ignore-whitespace_singular.no-translate',
		defaultMessage: 'equal ignore whitespace',
		description:
			'singular version of "equals-ignore-whitespace" operation. example: message does not equal ignore whitespace "critical"',
	},
	forAny: {
		id: 'eoc.routing-rules.common-messages.for-any-received-alert.no-translate',
		defaultMessage: 'for any received alert',
		description: 'Label of rule card condition',
	},
	errorTitle: {
		id: 'eoc.routing-rules.flag.error-title.no-translate',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
	successTitle: {
		id: 'eoc.routing-rules.flag.success-title.no-translate',
		defaultMessage: 'Success',
		description: 'Title of success message that will be displayed in the flag',
	},
	off: {
		id: 'eoc.routing-rules.common-messages.off.no-translate',
		defaultMessage: 'Off',
		description: 'Indicator text when one of the route all alerts to option is not enabled.',
	},
});

export default messages;
